module.exports = __webpack_public_path__ + "img/award_badge_long_third_2024.3318abaf.png";